module.exports = __webpack_public_path__ + "img/s3CardIcon2.ef391479.png";